import React, { useCallback, useState } from 'react';
import PersonalInformationScreen from 'components/medicalHistory/personalInformation';
import ContactInformationScreen from 'components/medicalHistory/contactInformation';
import InsuranceIdScreen from 'components/medicalHistory/insuranceId';
import SocialHistoryScreen from 'components/medicalHistory/socialHistory';
import FamilyHistoryScreen from 'components/medicalHistory/familyHistory';
import MedicalHistoryScreen from 'components/medicalHistory/medicalHistory';
import UploadRelevantMedicalRecords from 'components/medicalHistory/uploadRelevantMedicalRecords';
import SurgicalHistoryScreen from 'components/medicalHistory/surgicalHistory';
import PageCommonIssues from 'components/medicalHistory/PageCommonIssues';
import PageMedicalHistoryComplete from 'components/medicalHistory/medicalHistoryComplete';
import { actionTypeOfMedicalHistory } from 'reducer/actionType';
import AnyRecentIssues from 'components/medicalHistory/anyRecentIssuesScreen';
import PhotoId from 'components/medicalHistory/photoId';
import { skipInsuranceScreen } from 'components/medicalHistory/helpers';
import { useSelector } from 'react-redux';
import { NullableCommunique } from 'types/types';
import { RootState } from 'store/store';
import Header from 'components/common/header';
import PrimaryCarePhysician from 'components/medicalHistory/primaryCarePhysician';
import useBeforeUnload from 'hooks/useBeforeUnload';

function MedicalHistoryApp() {
  const totalPage = 13;
  const [currentPage, setCurrentPage] = useState(1);
  const [resultPage, setResultPage] = useState(false);
  useBeforeUnload(totalPage > currentPage);

  const communiqueData = useSelector(
    (state: RootState) => state.communique,
  ) as NullableCommunique;

  const nextOrSubmitButton = useCallback(
    (nextPage: number, submit?: boolean) => {
      if (submit) {
        setResultPage(true);
        setCurrentPage(100);
        return;
      }
      const skipInsurance = skipInsuranceScreen(communiqueData?.organizationId!, nextPage);
      if (skipInsurance) {
        nextPage += 1;
      }
      setCurrentPage(nextPage);
    },
    [],
  );

  const pageBackButton = (pageNumber: number) => {
    if (pageNumber === 0) {
      return;
    }
    const skipInsurance = skipInsuranceScreen(communiqueData?.organizationId!, pageNumber);
    if (skipInsurance) {
      pageNumber -= 1;
    }
    setCurrentPage(pageNumber);
  };

  return (
    <div
      className="app-page-container"
    >
      <Header
        currentPage={currentPage}
        totalPage={totalPage}
        onClickBackButton={pageBackButton}
      />
      <div className="pt-36 pb-20 px-3">
        {/* <PageOne /> */}
        {currentPage === 1 && (
          <PersonalInformationScreen
            currentPage={1}
            nextPage={2}
            actionPage={actionTypeOfMedicalHistory.PERSONAL_INFORMATION}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 2 && (
          <ContactInformationScreen
            currentPage={2}
            nextPage={3}
            actionPage={actionTypeOfMedicalHistory.CONTACT_INFORMATION}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 3 && (
          <PrimaryCarePhysician
            currentPage={3}
            nextPage={4}
            actionPage={actionTypeOfMedicalHistory.PRIMARY_CARE_PHYSICIAN}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 4 && (
          <InsuranceIdScreen
            currentPage={4}
            nextPage={5}
            actionPage={actionTypeOfMedicalHistory.INSURANCE_ID}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}

        {currentPage === 5 && (
          <PhotoId
            currentPage={5}
            nextPage={6}
            actionPage={actionTypeOfMedicalHistory.PHOTO_ID}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}

        {currentPage === 6 && (
          <SurgicalHistoryScreen
            currentPage={6}
            nextPage={7}
            actionPage={actionTypeOfMedicalHistory.SURGICAL_HISTORY}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 7 && (
          <MedicalHistoryScreen
            currentPage={7}
            nextPage={8}
            actionPage={actionTypeOfMedicalHistory.MEDICAL_HISTORY}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 8 && (
          <FamilyHistoryScreen
            currentPage={8}
            nextPage={9}
            actionPage={actionTypeOfMedicalHistory.FAMILY_HISTORY}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 9 && (
          <SocialHistoryScreen
            currentPage={9}
            nextPage={10}
            actionPage={actionTypeOfMedicalHistory.SOCIAL_HISTORY}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 10 && (
          <UploadRelevantMedicalRecords
            currentPage={10}
            nextPage={11}
            actionPage={actionTypeOfMedicalHistory.RELEVANT_MEDICAL_RECORDS}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 11 && (
          <AnyRecentIssues
            currentPage={11}
            nextPage={12}
            actionPage={actionTypeOfMedicalHistory.ANY_RECENT_ISSUES}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}

        {currentPage === 12 && (
          <PageCommonIssues
            currentPage={12}
            nextPage={13}
            actionPage={actionTypeOfMedicalHistory.ANY_RECENT_ISSUES_PAGES}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {resultPage && <PageMedicalHistoryComplete />}
      </div>
    </div>
  );
}

export default MedicalHistoryApp;
